import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const AdminLogin = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 grain" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-baseline gap-2 mb-3">
          <span className="font-serif text-3xl">Which</span>
          <span className="font-serif italic text-3xl text-primary">Media</span>
        </div>
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground mb-12">
          [ Content Management System ]
        </p>

        <form onSubmit={submit} className="space-y-8" data-testid="login-form">
          <div>
            <label className="font-mono text-xs uppercase tracking-[0.15em] text-muted-foreground">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-transparent border-b border-border focus:border-primary outline-none py-3 text-lg font-light transition-colors"
              placeholder="admin@whichmedia.com"
            />
          </div>
          <div>
            <label className="font-mono text-xs uppercase tracking-[0.15em] text-muted-foreground">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-transparent border-b border-border focus:border-primary outline-none py-3 text-lg font-light transition-colors"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full font-mono text-xs uppercase tracking-[0.18em] bg-primary text-primary-foreground py-4 hover:bg-primary/90 transition-colors disabled:opacity-40"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
